import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 rounded-lg overflow-hidden">
                <img 
                  src="/surekiln.jpg" 
                  alt="佛山信力凯" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    target.nextElementSibling?.classList.remove('hidden');
                  }}
                />
                <div className="w-full h-full bg-primary-600 flex items-center justify-center hidden">
                  <span className="text-white font-bold text-lg">信</span>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-bold">佛山信力凯</h3>
                <p className="text-sm text-gray-400">专业窑炉技术服务及设备制造</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              佛山市信力凯窑炉技术有限公司，致力于窑炉技术、燃烧及加热、自动化控制技术的应用与研发。公司专注于陶瓷行业、带钢退火等的窑炉设备及配套设施。
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <MapPin className="w-4 h-4" />
                <span>佛山市禅城区澜石（国际）金属交易中心第十三座二层36号铺</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Phone className="w-4 h-4" />
                <span>+86 17896504267</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Mail className="w-4 h-4" />
                <span>surekiln@163.com</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Globe className="w-4 h-4" />
                <span>www.surekiln.cn</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} 佛山市信力凯窑炉技术有限公司 版权所有
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <Link to="/contact" className="hover:text-primary-400 transition-colors duration-200">
                联系我们
              </Link>
              <a
                href="http://www.beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary-400 transition-colors duration-200"
              >
                粤ICP备2025489921号
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
